<template>
  <myDialog :isDialog="isShowCjmb" title="创建模版" @handleClose="$emit('handleClose')">
    <template slot="content">
      <myForm 
        ref="myFormRef" 
        labelWidth="150px" 
        :formData="formData" 
        :queryFn="queryAdd"
        @recombinationFormData="recombinationFormData"
        @successChange="successAddChange"
        >
      
        <template #mbwj="scope">
          <div class="mbwj">
            <el-input v-model="mbwj" placeholder="请输入内容"></el-input>
            <el-upload action="#" :show-file-list="false">
              <div class="uploadBtn">上传</div>
            </el-upload>
          </div>
        </template>
        <template #btn>
          <div class="hqbzdBtn">
            <img src="@/assets/images/sys/drpz/hqbzd-icon.png" alt="">
            <span>获取表字段</span>
          </div>
        </template>
        <template #ysgx>
          <el-table :cell-style="cellStyle" :data="tableData" :header-cell-style="headerStyle" style="width: 100%">
            <el-table-column prop="date" type="index" label="序号" width="160px" align="center"></el-table-column>
            <el-table-column prop="date" label="表字段">
              <template slot-scope="scope">
                <el-input v-model="scope.row.bzd" placeholder="请输入内容"></el-input>
              </template>
            </el-table-column>
            <el-table-column prop="name" label="主键"></el-table-column>
            <el-table-column prop="address" label="Excel列">
              <template slot-scope="scope">
                <el-input v-model="scope.row.lie" placeholder="请输入内容"></el-input>
              </template>
            </el-table-column>
          </el-table>       
        </template>
      </myForm>
    </template>
    <template slot="footer">
      <div class="cancelBtn" @click="next">下一步</div>
      <div class="cancelBtn" @click="$emit('handleClose')">保存</div>
    </template>
  </myDialog>
</template>

<script>
export default {
  props: {
    isShowCjmb: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      input:'',
      mbwj:'',
      step:1,
      formData: [        
        {
          label: '标题',
          type: 'input',
          key: 'bt'
        },
        {
          label: '数据库表名',
          type: 'input',
          key: 'sjkbm'
        },
        {
          label: '模版文件',
          type: 'slot',
          key: 'mbwj'
        },
        {
          label: '起始行',
          type: 'input',
          key: 'csh'
        },
        {
          label: '',
          type: 'slot',
          key: 'btn'
        },
        {
          labelWidth:'0px',
          text: '映射关系',
          type: 'subtitle',
          lineColor:'#E2EFFB',
        },
        {
          label: '',
          labelWidth:'0px',
          type: 'slot',
          key: 'ysgx'
        },
      ],
      tableData: [
        {
          bzd: '',
          zj: '',
          lie: ''
        },
      ]
    };
  },
  mounted() {
    
  },
  methods: {
    // 新增接口
    queryAdd(e){
      //新增接口，编辑接口
      return (e)=>{e}
    },
    // 添加保存传参
    recombinationFormData(param,callback){
      callback({...param})
    },
    successAddChange(e,formModel){
     
    },

   
    // 下一步
    next(){
      
      console.log(this.tableData,'213');
    },


    headerStyle() {
      return ' background: #9CC8F8;color: #2A3347;text-align: center;font-size: 14px; height: 34px;padding:0;border-right: 40px solid #fff;'
    },
    cellStyle() {
      return 'background: #F3F6FD!important;color: #2A3347;font-size: 14px;'
    },

  },
};
</script>

<style lang="scss" scoped>
.mbwj{
  display: flex;
  align-items: center;
  .uploadBtn{
    margin-left: 16px;
    width: 120px;
    height: 40px;
    border-radius: 4px;
    border: 1px dashed #0c7bf24d;
    background: #fcfcfc;
  }
}
.hqbzdBtn{
  cursor: pointer;
  width: 100%;
  height: 42px;
  border-radius: 3px;
  background: #1890ff;
  display: flex;
  justify-content: center;
  align-items: center;
  >span{
    color: #ffffff;
    font-weight: 500;
    font-size: 16px;
    margin-left: 24px;
  }
  >img{
    width: 24px;
    height: 24px;
  }
}
/deep/.el-form-item{
  margin-bottom: 8px;
}
/deep/.el-table__body{
  // -webkit-border-horizontal-spacing: 13px!important;  // 水平间距
  // -webkit-border-vertical-spacing: 8px!important;  // 垂直间距
}
</style>
